export default "/icon-nav-support.svg";